var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLogged())?_c('div',{staticClass:"exit"},[_c('a',{on:{"click":function($event){$event.preventDefault();return _vm.onClickLogout.apply(null, arguments)}}},[_vm._v("Выход")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }